export type AppraisalLetterType = "APPRAISAL" | "PROMOTION" | "APPRAISAL_WITH_PROMOTION";

export type EmployeeAppraisalValues = {
  employeeId: string;
  letterType: AppraisalLetterType;
  letterIssueDate: Date | null;
  effectiveDate: Date | null;
  noticePeriod: string;
  departmentId: string;
  designationId: string;
  designation: string;
  annualComponent: string;
  annualComponentRemarks: string;
};

export type AppraisalAnnexureValues = {
  annualCtc: string;
  monthlyGross: string;
  basic: string;
  pfEmployeePart: string;
  esicEmployeePart: string;
  specialAllowance: string;
  houseRentAllowance: string;
  conveyanceAllowance: string;
  helperAndDriver: string;
  lta: string;
  mealReimbursement: string;
  internetReimbursement: string;
  gymHealthClubReimbursement: string;
  gratuity: string;
  pfEmployerPart: string;
  esicEmployerPart: string;
  annualComponentEnabled: boolean;
  annualComponentAmount: string;
  annualComponentRemarks: string;
  remarks: string;
};

export const INITIAL_APPRAISAL_ANNEXURE_VALUES: AppraisalAnnexureValues = {
  annualCtc: "", monthlyGross: "", basic: "", pfEmployeePart: "1800", esicEmployeePart: "", specialAllowance: "", houseRentAllowance: "",
  conveyanceAllowance: "", helperAndDriver: "", lta: "", mealReimbursement: "",
  internetReimbursement: "1500", gymHealthClubReimbursement: "", gratuity: "",
  pfEmployerPart: "1800", esicEmployerPart: "", annualComponentEnabled: true, annualComponentAmount: "0",
  annualComponentRemarks: "", remarks: "",
};

export const INITIAL_EMPLOYEE_APPRAISAL_VALUES: EmployeeAppraisalValues = {
  employeeId: "",
  letterType: "APPRAISAL",
  letterIssueDate: null,
  effectiveDate: null,
  noticePeriod: "90 Days",
  departmentId: "",
  designationId: "",
  designation: "",
  annualComponent: "",
  annualComponentRemarks: "",
};
